<template>
  <div class="earn-view">
    <RecycoModal name="conversion-table-modal">
      <ConversionTable :products="products" />
    </RecycoModal>
    <div class="instructions">{{ $t('qr-code-instructions') }}</div>
    <RecycoButton @click.native="openConversionTableModal">{{ $t('see-conversion-table') }}</RecycoButton>
    <QrcodeVue :value="$auth.user.sub" level="H" :size="qrCodeSize" renderAs="svg" className="qr-code" />
  </div>
</template>

<i18n>
  {
    "es": {
      "qr-code-instructions": "Llevá tus reciclables a tu punto Recyco más cerca y mostrales este código para conseguir monedas",
      "see-conversion-table": "Ver tabla de conversión"
    },
    "en": {
      "qr-code-instructions": "Take your reciclables to your nearest Recyco station and show the operator this QR code to receive your RecyCoins",
      "see-conversion-table": "See conversion table"
    }
  }
</i18n>

<script>
  import QrcodeVue from 'qrcode.vue';
  import gql from 'graphql-tag';

  import { RecycoButton, RecycoModal } from '@/components/recyco';
  import ConversionTable from '@/components/ConversionTable.vue';

  export default {
    name: 'earn-view',
    components: {
      ConversionTable,
      RecycoButton,
      QrcodeVue,
      RecycoModal,
    },
    data() {
      return {
        qrCodeSize: 0,
        products: undefined,
      };
    },
    apollo: {
      products: {
        query: gql`query products {
          products {
            uuid
            name
            material
            value
          }
        }`,
        update: ({ products }) => products,
        fetchPolicy: 'cache-and-network',
      },
    },
    computed: {
      userId() {
        return this.$auth.user.id;
      },
    },
    methods: {
      openConversionTableModal() {
        this.$modal.show('conversion-table-modal');
      },
    },
    mounted() {
      this.qrCodeSize = this.$el.clientWidth / 2;
    },
  };
</script>

<style lang="scss" scoped>
  .earn-view {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 2em;
  }

  .conversion-table {
    width: 100%;
    height: 100%;
  }

  .instructions {
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
  }
</style>

<style lang="scss">
  .conversion-table-modal {
    border-radius: 1em;
  }
</style>
